import * as Sentry from "@sentry/react"
import axios from "axios"

const SENSITIVE_FIELDS = ["password", "token", "authorization"]

const scrubSensitive = (data: any): any => {
  if (typeof data === "string") {
    try {
      return scrubSensitive(JSON.parse(data))
    } catch {
      return data
    }
  }
  if (Array.isArray(data)) {
    return data.map(scrubSensitive)
  }
  if (data && typeof data === "object") {
    return Object.fromEntries(
      Object.entries(data).map(([key, value]) => [
        key,
        SENSITIVE_FIELDS.includes(key.toLowerCase()) ? "[Filtered]" : scrubSensitive(value),
      ]),
    )
  }
  return data
}

export const error = (name: string, error: any, extraData?: object) => {
  console.log(name, error)
  error.name = `${name} ${error?.message}`
  Sentry.withScope(scope => {
    if (axios.isAxiosError(error)) {
      scope.setExtra(
        "response",
        JSON.stringify({
          status: error.response?.status,
          data: error.response?.data,
        }),
      )
      scope.setExtra(
        "request",
        JSON.stringify({
          method: error.config?.method,
          url: error.config?.url,
          data: scrubSensitive(error.config?.data),
        }),
      )
    } else {
      scope.setExtra("error", JSON.stringify(error))
    }
    if (extraData) {
      scope.setExtra("data", JSON.stringify(extraData))
    }
    Sentry.captureException(error)
  })
}

export const SentryService = {
  error,
}
